import React, { Fragment, Component, } from 'react';
import Lightbox from 'react-images';

class LightBoxModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            classString: "columns small-12 medium-6 large-6 dual-block-image__item"
        };
    }
    componentDidMount() {
        if(this.props.images.length === 1) {
            this.setState({
                classString: "small-12 medium-12 large-12 dual-block-image__item"
            });
        }
    }


    render() {
        return (
                <Fragment>
                    {this.props.images && this.props.images.map((image, index) => 
                        <div className={this.state.classString} key={index} onClick={() => {this.props.onClickThumbnail(index);this.props.setVisibility(index)}                        }>
                            <a dangerouslySetInnerHTML={{ __html: image.imageHtml }}></a>
                        </div>
                    )}
                    <Lightbox
                        showThumbnails={true}
                        showImageCount={false}
                        isOpen={this.props.isVisible}
                        onClose={this.props.onClose}
                        currentImage={this.props.activeIndex}
                        {...this.props}
                    />
                </Fragment>
        )
    }
}
export default LightBoxModal
